import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';

const STORAGE_KEY = 'eva_interaction_type';
const DEFAULT_TYPE = 'audio';

const InteractionTypeContext = createContext(null);

export function InteractionTypeProvider({ children }) {
  const [interactionType, setInteractionTypeState] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored === 'text' ? 'text' : DEFAULT_TYPE;
    } catch {
      return DEFAULT_TYPE;
    }
  });

  const setInteractionType = useCallback((type) => {
    const validType = type === 'text' ? 'text' : 'audio';
    setInteractionTypeState(validType);
    try {
      localStorage.setItem(STORAGE_KEY, validType);
    } catch (e) {
      console.error('Error saving interaction type to localStorage:', e);
    }
  }, []);

  const isTextMode = useMemo(() => interactionType === 'text', [interactionType]);

  const value = useMemo(() => ({
    interactionType,
    setInteractionType,
    isTextMode,
  }), [interactionType, setInteractionType, isTextMode]);

  return (
    <InteractionTypeContext.Provider value={value}>
      {children}
    </InteractionTypeContext.Provider>
  );
}

export function useInteractionType() {
  const context = useContext(InteractionTypeContext);
  if (!context) {
    throw new Error('useInteractionType must be used within an InteractionTypeProvider');
  }
  return context;
}
